import { render, staticRenderFns } from "./packing-guide.vue?vue&type=template&id=36b4ff75&scoped=true&"
import script from "./packing-guide.vue?vue&type=script&lang=ts&"
export * from "./packing-guide.vue?vue&type=script&lang=ts&"
import style0 from "./packing-guide.vue?vue&type=style&index=0&id=36b4ff75&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4ff75",
  null
  
)

export default component.exports